import { useState } from "react";
import { BorderButton } from "src/components/buttons/BorderButton";
import InputRadio from "src/components/inputs/InputRadio";
import { InputRadioGroup } from "src/components/inputs/InputRadioGroup";
import Modal, { ModalProps } from "src/components/modals/Modal";
import UserModel from "src/models/UserModel";
import { modals, useModal } from "src/utils/modals";

interface Props extends ModalProps {
  fromUser: UserModel;
}

export const ChangePrimaryAccountModal = modals.create((props: Props) => {
  const modal = useModal();

  const [toUser, setToUser] = useState<UserModel>(props.fromUser);

  function onSubmit() {
    props.handleOk(toUser);
    modal.hide();
  }

  return (
    <Modal
      visible={modal.visible}
      handleCancel={modal.hide}
      afterClose={modal.remove}
      title={"Change Primary Account Owner"}
      footer={
        <>
          <BorderButton type="submit" onClick={onSubmit}>
            Save
          </BorderButton>
          <BorderButton onClick={modal.hide}>Cancel</BorderButton>
        </>
      }
    >
      <p>Choose the primary account owner.</p>

      <InputRadioGroup
        value={toUser?.id}
        onChange={(to) => {
          setToUser(props.fromUser.linkedAccounts.find((u) => u.id === to));
        }}
        border
      >
        <InputRadio
          value={props.fromUser.id}
          label={
            <>
              {props.fromUser.firstName} {props.fromUser.lastName}
              <div className="text-sm text-empty">{props.fromUser.email}</div>
            </>
          }
        />
        {props.fromUser.linkedAccounts.map((u) => {
          return (
            <InputRadio
              key={u.id}
              value={u.id}
              label={
                <>
                  {u.firstName} {u.lastName}
                  <div className="text-sm text-empty">{u.email}</div>
                </>
              }
            />
          );
        })}
      </InputRadioGroup>

      <p className="text-sm text-empty">
        Account owners will need to reload their screens if they’re currently
        signed in.
      </p>
    </Modal>
  );
});
